import React from "react";
import Icon from "../../../components/AppIcon";

const DeleteOrderModal = ({ isOpen, onClose, onConfirm, order, language }) => {
  if (!isOpen || !order) return null;

  const translations = {
    en: {
      deleteOrder: "Delete Order",
      confirmDelete: "Are you sure you want to delete this order?",
      orderNumber: "Order Number",
      cancel: "Cancel",
      delete: "Delete",
    },
    ar: {
      deleteOrder: "حذف الطلب",
      confirmDelete: "هل أنت متأكد من حذف هذا الطلب؟",
      orderNumber: "رقم الطلب",
      cancel: "إلغاء",
      delete: "حذف",
    },
  };

  const t = translations[language === "ar" ? "ar" : "en"];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full overflow-hidden">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center mb-4 gap-3">
            <div className="p-2 rounded-full bg-red-100">
              <Icon name="Trash2" size={24} className="text-red-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">
              {t.deleteOrder}
            </h3>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-3">{t.confirmDelete}</p>
            <p className="text-sm font-medium text-gray-900">
              {t.orderNumber}:{" "}
              <span className="text-red-600 font-mono">
                #{order.order_number}
              </span>
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
             <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              {t.cancel}
            </button>
            <button
              onClick={() => {
                onConfirm(order.id);
               
              }}
              className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
            >
              {t.delete}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteOrderModal;